import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";

const EditContactModal = ({ show, onClose, contact, onSubmit }) => {
  const [form, setForm] = useState({
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    gender: "",
    tags: "",
  });

  useEffect(() => {
    if (contact) {
      setForm({
        contactName: contact.contact_name || "",
        contactNumber: contact.contact_number || "",
        contactEmail: contact.contact_email || "",
        gender: contact.gender || "",
        tags: contact.tags?.join(",") || "",
      });
    }
  }, [contact]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    onSubmit({
      ...form,
      tags: form.tags.split(",").map((t) => t.trim()),
    });
  };

  if (!show) return null;

  return (
    <>
    <ToastContainer/>
    
    <div  className="montserrat-font-1" style={overlay}>
      <div className="montserrat-font-1" style={modal}>
        <h3 style={{ marginBottom: 20 }}>Edit Contact</h3>

        {/* Name */}
        <label style={label}>Name</label>
        <input
          name="contactName"
          placeholder="Enter name"
          value={form.contactName}
          onChange={handleChange}
          style={input}
        />

        {/* Number */}
        <label style={label}>Phone Number</label>
        <input
          name="contactNumber"
          placeholder="Enter phone number"
          value={form.contactNumber}
          onChange={handleChange}
          style={input}
        />

        {/* Email */}
        <label style={label}>Email</label>
        <input
          name="contactEmail"
          placeholder="Enter email"
          value={form.contactEmail}
          onChange={handleChange}
          style={input}
        />

        {/* Gender */}
        <label style={label}>Gender</label>
        <select
          name="gender"
          value={form.gender}
          onChange={handleChange}
          style={input}
        >
          <option value="">Select Gender</option>
          <option>Male</option>
          <option>Female</option>
        </select>

        {/* Tags */}
        <label style={label}>Tags</label>
        <input
          name="tags"
          placeholder="Enter tags (comma separated)"
          value={form.tags}
          onChange={handleChange}
          style={input}
        />

        <div className="flex gap-[10px] mt-5">
          <button onClick={onClose} style={cancelBtn}>
            Cancel
          </button>
          <button onClick={handleSubmit} style={submitBtn}>
            Submit
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modal = {
  background: "#fff",
  padding: 24,
  borderRadius: 10,
  width: 360,
};

const label = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  marginBottom: 4,
};

const input = {
  width: "100%",
  padding: 8,
  marginBottom: 12,
  border: "1px solid #ddd",
  borderRadius: 6,
};

const submitBtn = {
  background: "#25d366",
  border: "none",
  color: "#fff",
  padding: "8px 16px",
  borderRadius: 6,
  cursor: "pointer",
};

const cancelBtn = {
  background: "#eee",
  border: "none",
  padding: "8px 16px",
  borderRadius: 6,
};

export default EditContactModal;